import { render, staticRenderFns } from "./PopupLogout.vue?vue&type=template&id=08321bee&"
import script from "./PopupLogout.vue?vue&type=script&lang=js&"
export * from "./PopupLogout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports